export default __webpack_public_path__ + "static/arbitrum-logo-bdf393a7d923c7bb03bf8766572fe039.png";